export type GetPathType<
    Obj extends { [key: string]: any },
    Path extends string,
> = Path extends `${infer Left}.${infer Right}`
    ? Left extends keyof Obj
        ? `${Left}.${GetPathType<Obj[Left], Right>}`
        : `${Left}.${Path}`
    : Path extends keyof Obj
      ? `${Path}`
      : `${string & keyof Obj}`;

export type GetFieldType<Obj, Path extends string> = Path extends `${infer Left}.${infer Right}`
    ? Left extends keyof Obj
        ? GetFieldType<Obj[Left], Right>
        : undefined
    : Path extends keyof Obj
      ? Obj[Path]
      : undefined;

export type ObjectFullPaths<T> = T extends object
    ? {
          [K in Exclude<keyof T, symbol>]: T[K] extends object ? `${K}.${ObjectFullPaths<T[K]>}` : `${K}`;
      }[Exclude<keyof T, symbol>]
    : never;

type GetObjectFieldType<Obj, Path extends string> = Path extends `${infer Left}.${infer LeftPath}`
    ? Left extends keyof Obj
        ? LeftPath extends ObjectFullPaths<Obj[Left]>
            ? GetObjectFieldType<Obj[Left], LeftPath>
            : never
        : never
    : Path extends keyof Obj
      ? Obj[Path]
      : never;

type ObjectGetFunction = <T, Path extends string = ObjectFullPaths<T>>(
    object: T,
    path: Path,
    defaultValue?: any,
) => GetObjectFieldType<T, Path>;

const get: ObjectGetFunction = (object, path, defaultValue) => {
    const value = path
        .split(/[.]/)
        .filter(Boolean)
        .reduce((value, key) => (value as any)?.[key], object as any);

    return value ?? defaultValue;
};

export const Dict = { get };
